import type { Component } from 'solid-js'
import Button from '~/components/Button'
import Card from '~/components/Card'
import Form from '~/components/Form'
import Input from '~/components/Input'
import Switch from '~/components/Switch'
import Textarea from '~/components/Textarea'
import type { TabTributarioProps } from './types'

const TabTributario: Component<TabTributarioProps> = props => {
  return (
    <>
      <Card>
        <Card.Header>Información tributaria</Card.Header>
        <Card.Body>
          <Form id="tributario-form" onSubmit={props.handleSaveTributario} initialValues={props.initialValues(props.data)}>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <Input name="regimenTributario" label="Régimen tributario" placeholder="Simplificado, Común..." />
              <Input name="codigoCiiu" label="Código CIIU" />
              <Textarea name="obligacionesFiscales" label="Obligaciones fiscales" rows={3} class="lg:col-span-2" />
              <div class="lg:col-span-2 grid grid-cols-2 lg:grid-cols-4 gap-4">
                <Switch name="responsableIva" label="Responsable de IVA" />
                <Switch name="autoretenedor" label="Autoretenedor" />
                <Switch name="granContribuyente" label="Gran contribuyente" />
                <Switch name="agenteRetencion" label="Agente de retención" />
              </div>
            </div>
          </Form>
        </Card.Body>
      </Card>
      <div class="flex justify-end mt-4">
        <Button type="submit" form="tributario-form" disabled={props.isSaving()}>
          Guardar
        </Button>
      </div>
    </>
  )
}

export default TabTributario
